import { RJSFSchema, UiSchema } from "@rjsf/utils";

export type FileModalMode = "input-file" | "input-directory" | "output-file" | "output-directory";

export const getFileModalMode = (schema: RJSFSchema, uiSchema?: UiSchema): FileModalMode => {
  const isDirectory = schema.format === "rana_directory";
  const isOutput = !!uiSchema?.isOutput;

  if (isDirectory && isOutput) return "output-directory";
  if (isDirectory) return "input-directory";
  if (isOutput) return "output-file";
  return "input-file";
};

export const isDirectoryMode = (mode: FileModalMode) =>
  mode === "input-directory" || mode === "output-directory";

export const isOutputMode = (mode: FileModalMode) =>
  mode === "output-file" || mode === "output-directory";
